import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { HostListener } from '@angular/core';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { TranspaymentinfoComponent } from '../../grid/transpaymentinfo/transpaymentinfo.component';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { AddtranspaymodepopupComponent } from '../../generalpopup/addtranspaymodepopup/addtranspaymodepopup.component';
import { ActivitypopupComponent } from '../../grid/activitypopup/activitypopup.component';
@Component({
  selector: 'app-addairticket',
  templateUrl: './addairticket.component.html',
  styleUrls: ['./addairticket.component.css']
})
export class AddairticketComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "AIRTICKET";

  //Display
  formmode: string = "Add";
  rtnform: string = "";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;
  ispaymentmode: boolean = false;

  saveloading: boolean;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  isshowapproval: boolean = false;
  iscomments: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;

  ismanualclose: boolean;

  isemploading: boolean = false;
  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  filterpaymentstatus: string = "";

  //Edit Get Values
  airticketColl: any = [];
  airticketid: number = 0
  airticketBO: any = {}

  payrollColl: any = [];
  transpaymodeColl: any = [];
  empColl: any = [];
  empBO: any = {}

  checkfeildmsg: any = "";

  airticketform = new FormGroup({
    airticketid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    transdt: new FormControl(null, Validators.required),
    startdt: new FormControl(null, Validators.required),
    enddt: new FormControl(null, Validators.required),
    descr: new FormControl(''),
    orgin: new FormControl('', Validators.required),
    destination: new FormControl('', Validators.required),
    amount: new FormControl(null, Validators.required),
    inactive: new FormControl(false),
  });

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.airticketid = params.id
      }

      if (params.rtnform !== undefined) {
        this.rtnform = params.rtnform
      }
    });
    this.fnGetParameterVariable();

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }
  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
      if (params.paymentstatus !== undefined) {
        this.filterpaymentstatus = params.paymentstatus
      }
      
    })
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.airticketform.reset();
      this.fnInitializeFormGroup();

      if (this.airticketid > 0) {
        this.fngetAirticket();
      }

      this.fngetEmployee();
      this.fngetPayroll();


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.airticketid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')
    this.ispaymentmode = this.loginService.fnCheckUserRoleAction(this.formname, 'PAYMENT')


    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.airticketform.setValue({
      airticketid: 0,
      empid: null,
      transdt: new Date(),
      startdt: new Date(),
      enddt: new Date(),
      descr: '',
      orgin: '',
      destination: '',
      amount: null,
      inactive: false,

    })
  }

  fngetPayroll() {
    var data = {
      'payrollid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.fngetPayRollByListview(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.payrollColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetEmployee() {
    this.isemploading = true;
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading = false;
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading = false;
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetAirticket() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'airticketid': this.airticketid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getAirticket(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.airticketColl = res.json().result;
            var editdata = this.airticketColl[0];
            this.airticketBO = editdata;
            console.log(this.airticketBO)
            this.fnEditMode(editdata);
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }


  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.airticketform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }


  }

  fnResetValidation() {
    if (this.loginService.fnCheckFornControlNotfound(this.airticketform.get('enddt'))) {
      this.airticketform.controls['enddt'].setErrors(null);
    }
    if (this.loginService.fnCheckFornControlNotfound(this.airticketform.get('inactive'))) {
      this.airticketform.controls['inactive'].setErrors(null);
    }
  }
  fnSetValidation() {
    let _ischeck = false;
    if (this.loginService.fnCompareDateValidation(this.airticketform.get('enddt').value, this.airticketform.get('startdt').value)) {
      this.airticketform.controls['enddt'].setErrors({ 'notfound': true });
      _ischeck = true;
    }

    return _ischeck;
  }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate
      if (this.airticketform.valid) {

        if (this.fnSetValidation()) {
          return;
        }

        //Check
        var data = {
          'airticketid': this.airticketid,
          'empid': this.airticketform.get('empid').value,
          'transdt': this.fnFormatDatetime(this.airticketform.get('transdt').value),
          'startdt': this.fnFormatDatetime(this.airticketform.get('startdt').value),
          'enddt': this.fnFormatDatetime(this.airticketform.get('enddt').value),
          'descr': this.airticketform.get('descr').value,
          'orgin': this.airticketform.get('orgin').value,
          'destination': this.airticketform.get('destination').value,
          'amount': this.airticketform.get('amount').value,
          'inactive': this.airticketform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckAirticket(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;
              var _checkresponce = res.json().result[0];
              if (_checkresult === "done") {
                if (this.airticketform.get('airticketid').value > 0) {
                  //Update 
                  this.fnSetAirticket(data);
                }
                else {
                  //Insert 
                  this.fnInsertAirticket(data);
                }
              }
             
              else {
                this.saveloading = false;

                if (_checkresult === "date") {
                  this.airticketform.controls['enddt'].setErrors({ 'notfound': true });
                }
                else if (_checkresult === "exist") {
                  this.airticketform.controls['startdt'].setErrors({ 'notfound': true });
                }
                else if (_checkresult === "COMMON") {

                  this.checkfeildmsg = _checkresponce.checkvaluemsg;

                  this.airticketform.controls['inactive'].setErrors({ 'notfound': true });
                }

              }
            }
            else {
              this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }

          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }



  //Insert
  fnInsertAirticket(data) {

    this.appService.fnInsertAirticket(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag()
            this.toastr.success('', "The new Airticket has been added successfully.");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));

            var _result = res.json().result;
            if (_result.length > 0) {
              this.fnEditFormEdit(_result[0].airticketid);
            }

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetAirticket(data) {

    this.appService.fnSetAirticket(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag()
            this.toastr.success('', "The Airticket has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.airticketid, this.fngetDescriptionRefno(data));
            this.fnEditFormEdit(this.airticketid);

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }



  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }


  fnAddPaymentInfo() {

    const modalRef = this.productFindService.open(TranspaymentinfoComponent, { size: <any>'l' });
    modalRef.componentInstance.trid = this.airticketid;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.transdate = this.airticketBO.transdate;
    modalRef.componentInstance.transpaymodeid = this.airticketBO.transpaymodeid;
    modalRef.componentInstance.refno = this.airticketBO.payrefno;
    modalRef.componentInstance.paiddt = this.fnConvertDatetime(this.fnFormatDatetime(this.airticketBO.paiddt));
    modalRef.componentInstance.paymentinfo = this.airticketBO.paymentinfo;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === "DONE") {
        this.fngetAirticket();
      }

    });

  }


  fnEditFormEdit(id) {

    this.airticketid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


    let queryParams = {
      'id': id,
      'status': this.filterstatus,
      'empid': this.filteremployeeid,
      'empname': this.filteremployeename,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
      'paymentstatus':this.filterpaymentstatus,
      
    }



    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
      this.ngOnInit();
    });
  }
  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;

      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      } else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'status': this.filterstatus,
            'empid': this.filteremployeeid,
            'empname': this.filteremployeename,
            'fromdate': this.fnFormatDatetime(this.filterfromdate),
            'todate': this.fnFormatDatetime(this.filtertodate),
            'paymentstatus':this.filterpaymentstatus,
          }
        }

        this.router.navigate(['/Airticket'], navigationExtras);
      }


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));
    deptBO.startdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.startdt));
    deptBO.enddt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.enddt));

    this.airticketform.setValue({
      airticketid: deptBO.airticketid,
      empid: deptBO.empid,
      transdt: deptBO.transdt,
      startdt: deptBO.startdt,
      enddt: deptBO.enddt,
      descr: deptBO.descr,
      orgin: deptBO.orgin,
      destination: deptBO.destination,
      amount: deptBO.amount,
      inactive: deptBO.inactive

    });

    this.formmode = "Edit";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();

    this.fnChangeEmpLookup();

    this.fnGetAttachmentCount()
  }
  //Comment
  fnCommentsBtnClick() {

    this.iscomments = true;
  }

  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetAirticket();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.airticketBO.approvedstatus !== '') {
      if (this.airticketBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.airticketBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }


  //#Attachment
  fnAttachmentBtnClick() {

    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.airticketid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();


    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })


    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetAirticket();
      }
      this.fnGetAttachmentCount()
    });

  }


  fnAttachmentSave(tid) {



  }
  fnAddActivity(){

    const modalRef = this.productFindService.open(ActivitypopupComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.airticketid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {      

     
    });

  } 


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.airticketid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetAirticket();
      }


    });
  }




  //Attachment
  fnGetAttachmentCount() {
    if (this.airticketid > 0) {
      var data = {
        'trxid': this.airticketid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }


  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  fnResetSaveFlag() {
    this.submitted = false;
    this.successfully = false;
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}